import { React, useEffect, useState } from "react";
import "../../styles/desktop/AlarmeModal.css";
import LegendaCaixadagua from "./LegendaCaixaDagua/legendaCaixaDagua";
import Alarmes from "./AlarmeObjeto/Alarmes";
import { getLuzesStatusFlex8 } from "../../API/basic/FeedBackLuzes";

const GroupLightComponent = () => {
  const [luzesStatus, setLuzesStatus] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      
      const data = await getLuzesStatusFlex8();
      setLuzesStatus(data);
      console.log("Status das luzes Flex8:", data);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8200);
  
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className="CampoAlarme">
        <h1 className="tituloCampo4">Alarmes</h1>
        <div className="campoLegendaCaixadagua">
          <LegendaCaixadagua luzesStatus={luzesStatus}/>
        </div>
        <div className="campoAlarmes">
          <Alarmes luzesStatus={luzesStatus} />
        </div>
      </div>
    </>
  );
};

export default GroupLightComponent;